import styled from "styled-components";
import { Box } from "@mui/material";

export const MainContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.palette.text.tertiary}`,
  borderRadius: "4px",
  marginTop: "30px",
  position: "relative",
  padding: "32px 16px",
  display: "flex",
  flexDirection: "column",
}));

export const SectionTitle = styled(Box)(({ theme }) => ({
  padding: "5px",
  position: "absolute",
  top: 0,
  left: "10px",
  backgroundColor: theme?.palette.background.paper,
  transform: "translate(0, -50%)",
  color: theme.palette.text.primary,
}));

export const ExcludeWeekendsToggleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "start",
}));

export const AddButton = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  cursor: "pointer",
  borderBottom: `1px solid ${theme.palette.primary.main}`,
  alignSelf: "start",
  width: "fit-content",
  paddingBottom: "10px",
  userSelect: "none",
}));

export const SlotsGridItem = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "start",
}));

export const Divider = styled(Box)(({ theme }) => ({
  width: "100%",
  borderBottom: `1px solid ${theme.palette.text.tertiary}`,
}));

export const SingleSlotContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  width: "100%",
  paddingBottom: "20px",
}));

export const SingleSlotContent = styled(Box)(({ theme }) => ({
  marginLeft: "20px",
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
  },
}));
